<template>
  <div :class="{ 'checkbox-section mb-10': true }">
    <h3
      v-if="label"
      :class="{
        'pb-18px text-13px font-extrabold uppercase leading-none tracking-[2.08px] text-www-color-accent': true,
        'before:relative before:-top-1 before:left-0 before:mr-10px before:inline-block before:h-2px before:w-25px before:bg-www-color-accent before:content-[\'\']': true,
      }"
    >
      {{ label }}
    </h3>
    <div :class="{ 'grid grid-cols-1 gap-x-[26px] gap-y-[14px] md:grid-cols-2': true }">
      <div
        v-for="(checkboxItem, index) in checkboxItems"
        :key="index"
        :class="{ 'flex items-start gap-10px': true }"
      >
        <span
          :class="{
            'mt-px flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-www-color-accent-almost-white': true,
          }"
        >
          <CheckmarkIcon />
        </span>
        <span
          :class="{
            'text-base font-medium text-www-color-neutral-medium-dark': true,
          }"
        >
          {{ checkboxItem }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { CheckboxSection } from '~/sanity/types';
import CheckmarkIcon from '../CheckmarkIcon/CheckmarkIcon.vue';
defineProps<CheckboxSection>();
</script>

<style></style>
